module.exports = __webpack_public_path__ + "assets/StateAction.b47aca10.svg";